// Generated by CoffeeScript 2.7.0
var ORGANIZATION_NAME_SUFFIX, TAGGED_TYPES, UserBoundary;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import OrganizationSearch from 'trunks/vue/admin/components/search/organization.js';

import UserSearch from 'trunks/vue/admin/components/search/user.js';

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

TAGGED_TYPES = [
  {
    options: [
      {
        name: '交集（包含全部）',
        value: 'intersection'
      },
      {
        name: '并集（包含其一）',
        value: 'union'
      }
    ]
  }
];

ORGANIZATION_NAME_SUFFIX = '及以下组织';

export default UserBoundary = Vue.extend({
  components: {
    'filter-options': FilterOptions,
    'dropdown': DropdownSelect,
    'organization-search': OrganizationSearch,
    'user-search': UserSearch
  },
  props: {
    userBoundary: Object,
    taggedTypes: {
      default: function() {
        return TAGGED_TYPES;
      }
    },
    organizationNameSuffix: {
      default: ORGANIZATION_NAME_SUFFIX
    },
    type: {
      type: String,
      default: 'default'
    },
    calCountUrl: {
      type: String,
      default: '/admin/user_boundaries/count'
    }
  },
  data: function() {
    return {
      organization_ids: this.userBoundary.organization_ids || [],
      user_ids: this.userBoundary.user_ids || [],
      user_tag_ids: this.userBoundary.user_tag_ids || [],
      only_binded: this.userBoundary.only_binded || false,
      tagEnabled: _.any(this.userBoundary.user_tag_ids),
      tagGroups: [],
      currentTaggedType: this.userBoundary.user_tagged_type === 'union' ? this.taggedTypes[0].options[1] : this.taggedTypes[0].options[0],
      counting: false
    };
  },
  template: `<div class="user-boundary">
  <div class="user-boundary-select">
    <div class="select-wrapper">
      <h4>组织: </h4>
      <div class="justify-box organizations-search-wrapper">
        <div class="content">
          <organization-search ref='organizations'
                               remote='/admin/organizations/query?enhanced=true'
                               @valueChanged='updateOrganizations'
                               :organizationNameSuffix='organizationNameSuffix'
                               :organizationsCounterText='countInfo.organizations_count'
                               :selectedOrganizationIds='userBoundary.organization_ids' />
        </div>
        <div class="vertical-middle clickable toggle-tag-btn" @click='toggleTagEnabledFunc'>
          <i class="slp-check" v-if='tagEnabled'></i>
          <i class="slp-empty" v-else></i>
          <span>用户标签</span>
        </div>
      </div>
      <div class="justify-box" v-show='tagEnabled'>
        <div class="content organizations-search-tags">
          <filter-options ref='tags'
                          :multiple='true'
                          :groupedOptions='tagGroups'
                          @valueChanged='updateTags' />
        </div>
        <dropdown :optionGroups='taggedTypes'
                  :initValue='currentTaggedType'
                  @change='updateTaggedType'
                  ref='tagedType'>
          <template slot='value-template' slot-scope='{ option }'>
            <span>{{ option.name }}</span>
          </template>
          <template slot='option-template' slot-scope='{ option }'>
            <span>{{ option.name }}</span>
          </template>
        </dropdown>
      </div>
      <div class="justify-box">
        <label class="vertical-middle">
          <input type="checkbox" hidden='true' :checked='only_binded' @change='toggleOnlyBinded' />
          <i class="slp-square-o"></i>
          <span>&nbsp;限绑定用户</span>
        </label>
      </div>
    </div>
    <div class="select-wrapper">
      <h4>个人: </h4>
      <user-search ref='users'
                   remote='/admin/users/query'
                   @valueChanged='updateUsers'
                   popoverPosition='bottom'
                   :selectedUserIds='userBoundary.user_ids' />
    </div>
    <div class="select-wrapper">
      <div class="placeholder" v-if='counting'>计算人数中...</div>
      <div v-else class="tips" v-html="countInfoText">
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    this._fetchTagGroups();
    this.countInfo = {};
    return this.countInfoText = null;
  },
  mounted: function() {
    return this._calculteCount();
  },
  watch: {
    counting: function() {
      return this.countInfoText = this.type === 'default' ? `组织+个人共计: <span>${this.countInfo.users_count || 0}</span>人` : `共选择 <span class='black-text bold-text'>${this.countInfo.total || 0}</span> 个接收者，需要追加的接收者有 <span class='black-text bold-text'>${this.countInfo.new_recipient_count || 0}</span> 个`;
    }
  },
  methods: {
    setUserBoundary: function(ub) {
      this.organization_ids = ub.organization_ids;
      this.user_ids = ub.user_ids;
      this.user_tag_ids = ub.user_tag_ids;
      this.only_binded = ub.only_binded;
      this.tagEnabled = _.any(ub.user_tag_ids);
      this.countInfo = {
        users_count: ub.users_count,
        organizations_count: ub.organizations_count
      };
      this.currentTaggedType = _.findWhere(this.taggedTypes[0].options, {
        value: ub.user_tagged_type || 'intersection'
      });
      this.$refs.organizations.setValue(this.organization_ids);
      this.$refs.users.setValue(this.user_ids);
      this._setUserTags(ub.user_tag_ids || []);
      return this.$refs.tagedType.select(this.currentTaggedType);
    },
    getData: function() {
      var ub;
      ub = _.pick(this, 'user_ids', 'organization_ids', 'only_binded');
      if (this.tagEnabled) {
        _.extend(ub, {
          user_tag_ids: this.user_tag_ids,
          user_tagged_type: this.currentTaggedType.value
        });
      }
      return ub;
    },
    getValue: function() {
      return _.extend({
        user_tagged_type: 'intersection',
        user_tag_ids: []
      }, this.getData(), {
        users: this._pickCollection(this.$refs.users.selectedItems, 'id', 'name', 'headimgurl'),
        organizations: this._pickCollection(this.$refs.organizations.selectedItems, 'id', 'composedName', 'name'),
        user_tags: this._pickCollection(this.$refs.tags.selectedOptions, 'id', 'name')
      });
    },
    toggleOnlyBinded: function(event) {
      this.only_binded = event.target.checked;
      return this._emitValueChanged();
    },
    updateUsers: function() {
      this.user_ids = _.pluck(this.$refs.users.selectedItems, 'id');
      return this._emitValueChanged();
    },
    updateOrganizations: function() {
      this.organization_ids = _.pluck(this.$refs.organizations.selectedItems, 'composedId');
      return this._emitValueChanged();
    },
    updateTags: function() {
      this.user_tag_ids = _.pluck(this.$refs.tags.selectedOptions, 'id');
      return this._emitValueChanged();
    },
    updateTaggedType: function(taged) {
      this.currentTaggedType = taged;
      return this._emitValueChanged();
    },
    toggleTagEnabledFunc: function() {
      this.tagEnabled = !this.tagEnabled;
      if (_.isEmpty(this.user_tag_ids)) {
        return;
      }
      return this._emitValueChanged();
    },
    _pickCollection: function(list, ...keys) {
      return _.map(list, function(obj) {
        return _.pick.apply(null, [obj].concat(keys));
      });
    },
    _setUserTags: function(ids = this.user_tag_ids) {
      this.tagGroups = _.map(this.rawTagGroups, function(_group) {
        var group;
        group = _.clone(_group);
        group.multiple = true;
        group.options = _.map(group.options || group.tags, function(_option) {
          var option;
          option = _.clone(_option);
          option._selected = _.contains(ids, option.id);
          return option;
        });
        return group;
      });
      return this.$nextTick(function() {
        return this.updateTags();
      });
    },
    _fetchTagGroups: function() {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('/tag_groups/user.json'), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json'
      }).done((data, xhr) => {
        this.rawTagGroups = data;
        return this._setUserTags();
      });
    },
    _emitValueChanged: function() {
      this.counting = true;
      return this.__debounceEmitValueChanged();
    },
    __debounceEmitValueChanged: _.debounce(function() {
      this._calculteCount();
      return this.$emit('valueChanged', this);
    }, 1000),
    _calculteCount: function() {
      var data;
      data = this.getData();
      if (_.isEmpty(data.user_ids) && _.isEmpty(data.organization_ids)) {
        this.countInfo = {};
        return this.counting = false;
      } else {
        this.counting = true;
        return Skylark.Libs.Ajax.post(this.calCountUrl, {
          data: {
            user_boundary: data
          },
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: (data, xhr) => {
            this.countInfo = data;
            return this.$emit('valueChanged', this);
          },
          complete: () => {
            return this.counting = false;
          }
        });
      }
    }
  }
});
